import { toast } from "react-toastify";
import { YieldSheetService } from "../services";
import { YieldApi } from "api/yield";

const downloadFile = async function (
  hotelId: number,
  filename: string,
  overiddenFileName: string,
) {
  try {
    const res = await YieldApi.getDownloadLink({
      hotelId,
      filename,
      overiddenFileName,
    });
    const link = document.createElement("a");
    link.href = res.url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    toast.error("Download failed");
    console.log(err);
  }
};

const deleteFile = function (hotelId: number, id: string) {
  return new Promise<void>(async (resolve, reject) => {
    try {
      await YieldSheetService.revanista.files.delete(hotelId, id, name);
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};

export default {
  downloadFile,
  deleteFile,
};
